<!-- 
  MesFilter 组件
  输入参数： {string} entity 组件名称
  生成 List 页面中常用的搜索过滤器
  自带搜索按钮和清除按钮
 -->
<template>
  <div>
    <div class="card">
      <div
        id="collapseOne"
        class="collapse show"
        aria-labelledby="headingOne"
        data-parent="#accordionFilter"
      >
        <div class="card-body">
          <form class="row">
            <div class="form-group col-md-2" v-for="(item, index) in modelGridFilter" :key="index">
              <label class="control-label">{{ $t(item.label) }}:</label>
              <mmf-form-helper
                is-editing
                :name="item.key"
                :metadata="item"
                :value="storeFilter[item.key]"
                @input="v=>storeFilter[item.key]=v"
                @bind="v=>storeFilter[item.key]=v"
              />
            </div>
            <div class="col-lg-12 align-self-end">
              <div class="float-lg-right">
                <button
                  class="btn btn-outline-secondary mr-1"
                  type="button"
                  v-on:click="MMFClearFilter(entity)"
                >
                  <i class="fa fa-fw fa-lg fa-eraser"></i>
                  <span class="text">{{ $t("btn.basic.clear") }}</span>
                </button>
                <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows(entity)">
                  <i class="fa fa-fw fa-lg fa-search"></i>
                  <span class="text">{{ $t("btn.basic.search") }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import vuexHelper from "@/mixin/vuexHelper";
import models from "@/model";
import MmfFormHelper from "@/components/MmfFormHelper";

export default {
  mixins: [vuexHelper],
  components: {
    MmfFormHelper
  },
  props: {
    /**
     * 模块名称 如 shipPlan, teamShift
     */
    entity: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      moduleName: this.entity
    };
  },
  computed: {
    model() {
      return models[this.entity];
    },
    modelGridFilter() {
      return this.model.gridFields().filter(v => v.filterable);
    },
    storeFilter() {
      const filter = this.modelGridFilter;
      const mapping = filter.reduce((prev, v) => {
        const key = v.key;
        prev[key] = `filter.${key}Filter`;
        return prev;
      }, {});
      return this.reactiveStates(mapping);
    }
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"])
  }
};
</script>

<style>
</style>